
import Vue from 'vue';
import GlassButton from '@/components/base/GlassButton.vue';
import PurpleChip2 from '@/components/base/PurpleChip2.vue';

export default Vue.extend({
	name: 'RewardButton',
	components: {
		GlassButton,
		PurpleChip2,
	},
	props: {
		text: {
			type: String,
			required: true,
		},
		completedText: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: 'mdi-star-outline',
		},
		isCompleted: {
			type: Boolean,
			default: false,
		},
		rewardAmount: {
			type: [Number, String],
			default: 100,
		},
		showReward: {
			type: Boolean,
			default: true,
		},
		buttonStyles: {
			type: Object,
			default: () => ({
				width: '100%',
				padding: '14px',
				borderRadius: 'var(--global-border-radius-md)',
			}),
		},
	},
});
